import apiClient from '../api/client';

export const getDashboardStats = async () => {
  const { data } = await apiClient.get('/admin/dashboard');
  return data;
};
